var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-card-heading"},[_c('h1',{staticClass:"text-title uppercase text-center"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"login-card-text text-highlight text-center text-neutral-clear font-normal mt-4"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }